<script>
  export let reviewerName
  export let verifiedText
  export let isVerifiedBuyer
  export let isVerifiedReviewer
  export let widgetNameColor
  export let isProductWidget = false
  export let marginLeft = 0
  export let textColor

  const isVerified = isVerifiedBuyer || isVerifiedReviewer

  const verifiedBuyerIconColorMap = {
    true: '#00AB06',
    false: '#0694EA'
  }
</script>

<style>
  :global(.reviewer__profile-name-1qm3B7) {
    text-align: left;
  }

  :global(.reviewer__verified-info-2P91R9) {
    display: flex;
    align-items: center;
  }

  :global(.reviewer__verified-info-2P91R9) :global(.verified_icon-1ZfwML) {
    margin: 0 3px 0 10px;
    position: relative;
    height: 16px;
  }

  :global(.reviewer__verified-info-2P91R9) :global(.verified_text-2rXhqR) {
    color: #7a8998;
  }

  .reviewer__name-product-widget {
    display: block;
    font-weight: 600;
    margin-bottom: 4px;
    margin-top: 1rem;
    float: none !important;
  }

  :global(.reviewer__verified-info-2P91R9) .verified-check {
    margin: 0 3px 0 -3px;
  }

  @media only screen and (max-width: 500px) {
    .profile-name {
      display: flex;
      flex-direction: column;
    }

    :global(.reviewer__verified-info-2P91R9) .verified-check {
      margin: 0 6px 0 0;
      position: relative;
      margin-top: 6px;
    }
  }
</style>

<div class:profile-name={isProductWidget}>
  <span
    class="reviewer__profile-name-1qm3B7"
    class:reviewer__name-product-widget={isProductWidget}
    style="color: {widgetNameColor} !important; float: {isVerified ? 'left' : 'none'};
    margin-left:{marginLeft}rem;">
    {reviewerName}
  </span>
  {#if isVerified}
    <div class="reviewer__verified-info-2P91R9">
      <div class="verified_icon-1ZfwML" class:verified-check={isProductWidget}>
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 49 (51002) - http://www.bohemiancoding.com/sketch -->
          <!-- <desc>Created with Sketch.</desc> -->
          <defs />
          <g
            id="Widget-"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd">
            <g id="sample-1" transform="translate(-222.000000, -321.000000)">
              <g id="Group-5" transform="translate(10.000000, 263.000000)">
                <g id="Group-3" transform="translate(23.000000, 33.000000)">
                  <g id="Group" transform="translate(38.000000, 0.000000)">
                    <g id="Group-4" transform="translate(15.000000, 15.000000)">
                      <g id="Group-5" transform="translate(4.000000, 0.000000)">
                        <g
                          id="Group-6"
                          transform="translate(61.000000, 6.000000)">
                          <g
                            transform="translate(67.000000, 0.000000)"
                            id="ico_verified">
                            <g>
                              <g>
                                <g id="base_icon" fill="#FFFFFF" opacity="0">
                                  <rect
                                    id="Rectangle-2"
                                    x="0"
                                    y="0"
                                    width="24"
                                    height="24" />
                                </g>
                                <circle
                                  id="Oval"
                                  fill={verifiedBuyerIconColorMap[isVerifiedBuyer]}
                                  cx="12"
                                  cy="12"
                                  r="8" />
                                <path
                                  d="M9.364119,11.1417662 C8.99259197,10.7782322
                                  8.39670722,10.7847118 8.03317316,11.1562388
                                  C7.66963909,11.5277658 7.67611867,12.1236506
                                  8.0476457,12.4871846 L10.262717,14.6546012
                                  C10.6320307,15.0159696 11.2236189,15.0120312
                                  11.5880885,14.6457777 L15.9018088,10.3109445
                                  C16.2684627,9.942496 16.2670079,9.34657779
                                  15.8985595,8.97992389 C15.530111,8.61326998
                                  14.9341928,8.61472475 14.5675389,8.9831732
                                  L10.9121297,12.6564733 L9.364119,11.1417662 Z"
                                  id="Line"
                                  fill="#FFFFFF"
                                  fill-rule="nonzero" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div
        class="verified_text-2rXhqR"
        style="display: block; font-size: 12px; padding-top: 2.5px; color: {textColor};">
        {verifiedText}
      </div>
    </div>
  {/if}
</div>
